import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const contactRoutes: RouteRecordRaw[] = [
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/modules/contacts/views/ContactListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
